module.exports = __webpack_public_path__ + "assets/img/tdc.601e240f.png";